import ICompanyInfo from "./compnay.interface";


export default class CompanyService {
  private ACNUrl: string = 'https://abr.business.gov.au/json/AcnDetails.aspx?callback=acnCallback';
  private ABNUrl: string = 'https://abr.business.gov.au/json/AbnDetails.aspx?callback=abnCallback';

  private readonly Guid: string = "c8f80ff6-5b27-43cd-9e08-78b1bbf6d890";

  private readonly CallbackRegex = /[abnCallback|acnCallback].*\((\{.*\})\)/gm;
  private readonly ACNNumberLength = 9;

  constructor(public number: number) { }

  async getInformation(): Promise<ICompanyInfo> {
    let response;
    if (this.number == this.ACNNumberLength) {
      response = await this.getACNDetails();
    } else {
      response = await this.getABNDetails();
    }

    return response;
  }

  private generateACNRequest(): string {
    return `${this.ACNUrl}&acn=${this.number}&guid=${this.Guid}`
  }
  private generateABNRequest(): string {
    return `${this.ABNUrl}&abn=${this.number}&guid=${this.Guid}`
  }

  private getACNDetails(): Promise<ICompanyInfo> {
    return new Promise<ICompanyInfo>((resolve, reject) => {
      fetch(this.generateACNRequest()).then(response => response.text()).then(text => {
        resolve(this.convertToJson(text));
      }).catch(error => reject(error));
    });

    // fetch(this.generateACNRequest()).then(response => response.text());
  }

  private getABNDetails(): Promise<ICompanyInfo> {
    return new Promise<ICompanyInfo>((resolve, reject) => {
      fetch(this.generateABNRequest()).then(response => response.text()).then(text => {
        resolve(this.convertToJson(text));
      }).catch(error => reject(error));
    });
  }

  private convertToJson(text: string): ICompanyInfo {
    const [result] = Array.from(text.matchAll(this.CallbackRegex)).map(match => match[1]);

    return JSON.parse(result);
  }

}

interface Response {
  status: number;
  statusText: string;
  headers: Headers;
  ok: boolean;
  json(): any;
  text(): string;
}

interface AcnDetails {

}
interface AbnDetails {

}